export * from './chips';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/chips/index.js
// module id = 742
// module chunks = 4